<p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)" [style]="{ width: '450px' }"
          header="Detalhes do diretório" [modal]="true">
    <ng-template #content>
        <form [formGroup]="directoryForm" (ngSubmit)="save.emit()">
            <div class="flex flex-col gap-6">
                <div>
                    <label for="name"
                              class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">Nome</label>
                          <input pInputText id="name" type="text" placeholder="Nome da pasta" class="w-full md:w-[30rem] mb-2"
                           formControlName="name" />
                    <div *ngIf="name?.invalid && (name?.touched || name?.dirty)" class="text-red-500 text-sm mb-2">
                        <div *ngIf="name?.errors?.['required']">O nome é obrigatório.</div>
                        <div *ngIf="name?.errors?.['name']">Formato de nome inválido.</div>
                    </div>
                </div>

            </div>
        </form>
    </ng-template>

    <ng-template #footer>
        <p-button *ngIf="!isLoading" label="Cancelar" severity="danger" icon="pi pi-times" text (click)="visibleChange.emit()" />
        <p-button label="Salvar" icon="pi pi-check"
                  [disabled]="isLoading || !directoryValidation()"
                  [loading]="isLoading"
                  (click)="save.emit(this.id)" />
    </ng-template>
</p-dialog>
